import React from "react";
import { Formik } from "formik";
import { Col, Row, Button, notification } from "antd/lib/index";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { editViaje } from "../../../../redux/actions/viajes";
import GeneralInput from "./GeneralInput";
import EtapasInput from "../etapas/EtapasInput";
import { selectCurrentViaje } from "../../../../redux/selectors/viajes";

class EditViajeForm extends React.Component {
  openNotificationWithIcon = type => {
    notification[type]({
      message: "Viaje editado exitosamente"
    });
  };

  render() {
    return (
      <Formik
        initialValues={{ ...this.props.viaje }}
        onSubmit={(values, actions) => {
          this.props.onEditViaje(values);
        }}
        render={props => (
          <React.Fragment>
            <Row gutter={8}>
              <Col span={12}>
                <GeneralInput
                  values={props.values}
                  handleChange={props.handleChange}
                  handleBlur={props.handleBlur}
                />
              </Col>
              <Col span={12}>
                <EtapasInput
                  values={props.values}
                  handleChange={props.handleChange}
                  handleBlur={props.handleBlur}
                />
              </Col>
            </Row>
            <Row>
              <Button onClick={props.handleSubmit}>Submit</Button>
            </Row>
          </React.Fragment>
        )}
      />
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ onEditViaje: editViaje }, dispatch);

const mapStateToProps = (state, ownProps) => {
  const viajeId = ownProps.computedMatch.params.id;
  const viaje = selectCurrentViaje(state, viajeId)[0];

  return {
    viaje
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditViajeForm);
